module.exports = __webpack_public_path__ + "static/media/GURU SHIKHAR SMALL AND BIG.c9d0425a.png";